import {useStorage} from "@vueuse/core";
import {ref} from "vue";

export default {
    sidebarOpen: ref(false),
    calendarSidebar: useStorage('portal-calendar-sidebar-open', true)
};
